import * as React from 'react';
import { useRecordContext } from 'react-admin';

import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import AlarmAddIcon from '@material-ui/icons/AlarmAdd';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';

import { TIPO_OFERTA_PRODUTO_JORNAL } from '../../utils';

function getDataMaximaStatus(data_maxima) {
  const timeDataLimite = new Date(data_maxima).getTime();
  const timeDataAtual = new Date().getTime();

  if (timeDataLimite > timeDataAtual) {
    return true;
  }

  return false;
}

const ActionsField = ({
  handleEdit = () => {},
  handleShow = () => {},
  handleDeletar = () => {},
  handleEstenderOferta = () => {},
  ...rest
}) => {
  const record = useRecordContext(rest);

  const dataMaximaStatus = record
    ? record.record
      ? getDataMaximaStatus(record.record.data_maxima)
      : false
    : false;

  const status = record
    ? record.record
      ? record.record.status
      : false
    : false;

  const statusFinal = dataMaximaStatus && status;

  const isTipoJornal = record
    ? record.record
      ? record.record.tipo === TIPO_OFERTA_PRODUTO_JORNAL
      : false
    : false;

  return (
    <div
      style={{
        marginRight: '0px',
        display: 'flex',
        justifyContent: 'flex-end',
      }}
    >
      {/*<Tooltip title="Detalhes" placement="bottom" aria-label="detalhes">
        <IconButton
          aria-label="detalhes"
          size="small"
          onClick={() => handleShow(record.record)}
        >
          <VisibilityIcon />
        </IconButton>
    </Tooltip>*/}
      {statusFinal && isTipoJornal ? (
        <Tooltip
          title="Estender Oferta por 1 semana"
          placement="bottom"
          aria-label="estender-oferta"
        >
          <IconButton
            aria-label="estender-oferta"
            size="small"
            onClick={() => handleEstenderOferta(record.record)}
          >
            <AlarmAddIcon />
          </IconButton>
        </Tooltip>
      ) : null}

      {statusFinal ? (
        <Tooltip title="Editar" placement="bottom" aria-label="editar">
          <IconButton
            aria-label="editar"
            size="small"
            onClick={() => handleEdit(record.record)}
          >
            <EditIcon />
          </IconButton>
        </Tooltip>
      ) : null}

      {statusFinal ? (
        <Tooltip title="Deletar" placement="bottom" aria-label="deletar">
          <IconButton
            aria-label="deletar"
            size="small"
            onClick={() => handleDeletar(record.record)}
          >
            <DeleteOutlineIcon />
          </IconButton>
        </Tooltip>
      ) : null}
    </div>
  );
};

export default ActionsField;
